import { compose, isEmpty, isNil } from 'ramda';

import { mapToQueryString } from 'utils/http';

let beUrl = '';

const concatBeUrl = (beUrl) => (url) => {
	return beUrl + url;
};

// example/:id
const applyParams = (params) => (url) => {
	if (!isNil(params) && !isEmpty(params)) {
		for (const i in params) {
			const replace = `:${i}`;
			url = url.replace(replace, params[i]);
		}
	}

	return url;
};

// example?id=:id
const applyQueryParams = (queryParams) => (url) => {
	if (!isNil(queryParams) && !isEmpty(queryParams)) {
		url += `${url.indexOf('?') > 0 ? '&' : '?'}${mapToQueryString(queryParams)}`;
	}

	return url;
};

export const setBaseUrl = (url) => (beUrl = url);

/**
 * Use to generate an URL and avoid hardcoded values
 */
export const generateUrl = (url, params, queryParams, useBaseUrl = true) =>
	compose(
		(newUrl) => {
			if (useBaseUrl) {
				return concatBeUrl(beUrl)(newUrl);
			} else {
				return newUrl;
			}
		},
		applyParams(params),
		applyQueryParams(queryParams),
	)(url);
